import { Button, DatePicker, Input, Radio, Table } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { programColumns, useGetProgramList } from "./model";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";

const Program = () => {
    const [fillteredDataList, setFillteredDataList] = useState<IProgramForList[]>([]);
    const [filterDateList, setFilterDateList] = useState<[Dayjs | undefined, Dayjs | undefined]>([undefined, undefined])
    const [filterIsDisplay, setFilterIsDisplay] = useState<boolean | undefined>();
    const [filterTitle, setFilterTitle] = useState<string>('')
    const navigate = useNavigate()
    const { data: dataList = [], isFetching } = useGetProgramList()
    const onFilterDataList = () => {
        const fillterdData = dataList?.filter(q =>
            ((filterDateList[0] === undefined || filterDateList[0].isBefore(q.createDateTime)) && (filterDateList[1] === undefined || filterDateList[1].isAfter(q.createDateTime)))
            && (filterIsDisplay === undefined || filterIsDisplay === q.isDisplay)
            && (filterTitle === '' || q.title.includes(filterTitle))
        )
        setFillteredDataList(fillterdData.sort((a, b) => dayjs(b.createDateTime).diff(dayjs(a.createDateTime))))
    }
    const convertDataToCsvData = (data?: IProgramForList[]) => {
        return data?.map((item) => ({
            id: item.id,
            "프로그램명": item.title,
            "생성일": dayjs(item.createDateTime)?.format('YYYY.MM.DD'),
            "프로그램 기간": `${dayjs(item.programPeriod?.[0])?.format('YYYY.MM.DD')} ~ ${dayjs(item.programPeriod?.[1])?.format('YYYY.MM.DD')}`,
            "게시여부": item.isDisplay ? '게시' : '미게시',
            "예약 목록": item.bookingCnt,
        })) ?? []
    }

    useEffect(() => {
        if (dataList?.length <= 0) return;
        onFilterDataList()
    }, [filterTitle, filterIsDisplay, filterDateList])

    useEffect(() => {
        onFilterDataList()
    }, [isFetching])

    return <>
        <div style={{ paddingBottom: '56px' }}>
            <div style={{ width: '50%', display: 'flex', alignItems: 'center', paddingBottom: '24px' }}>
                <div style={{ flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>
                    생성일
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', flex: 3 }}>
                    <DatePicker.RangePicker
                        onChange={dates => {
                            if (dates) {
                                setFilterDateList(dates as [Dayjs | undefined, Dayjs | undefined]);
                            } else {
                                setFilterDateList([undefined, undefined]);
                            }
                        }}
                        value={filterDateList} />
                    <div style={{ width: '56.32px' }} />
                </div>
            </div>
            <div style={{ width: '50%', display: 'flex', alignItems: 'center', paddingBottom: '24px' }}>
                <div style={{ height: '32px', flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '32px' }}>
                    게시여부
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', flex: 3 }}>
                    <Radio.Group defaultValue={undefined} value={filterIsDisplay} onChange={q => setFilterIsDisplay(q.target.value)}>
                        <Radio value={undefined}>
                            전체
                        </Radio>
                        <Radio value={true}>
                            게시
                        </Radio>
                        <Radio value={false}>
                            미게시
                        </Radio>
                    </Radio.Group>
                </div>
            </div>
            <div style={{ display: 'flex', paddingBottom: '24px' }}>
                <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
                    <div style={{ flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>
                        검색
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', flex: 3 }}>
                        <Input style={{ width: '406px' }} placeholder="프로그램명 검색" value={filterTitle} defaultValue={filterTitle} onChange={q => setFilterTitle(q.target.value)} onPressEnter={onFilterDataList} />

                    </div>
                </div>
                <Button type='primary' onClick={onFilterDataList}>검색</Button>
            </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '32px' }}>
            <div>
                검색 결과 ({fillteredDataList?.length})
            </div>
            <div>
                <Button>
                    <CSVLink filename={"프로그램-" + fillteredDataList?.[0]?.title?.replaceAll(' ', '') + '-' + dayjs().format("YYYY-MM-DD HH_mm_ss")} data={convertDataToCsvData(fillteredDataList)}>CSV 다운로드</CSVLink>
                </Button>
                <Button style={{ marginLeft: '20px', border: '1px solid #1677FF' }} type='link' onClick={_ => navigate('/wellness-program/program/create')}>+ 프로그램 생성</Button>
            </div>
        </div>
        <div>
            <Table dataSource={fillteredDataList} rowKey={'id'} columns={programColumns} loading={isFetching} />
        </div>
    </>
}

export { Program }